const urlGenerator = path => path.replace(/\d{2,}-/g, '')

const getCollapseState = (part, location) => {
	return !(location && location.pathname.includes(urlGenerator(part)))
}

const calculateTreeData = (edges, defaultCollapsed, location) =>
	edges.reduce(
		(
			acc,
			{
				node: {
					fields: { slug, modSlug },
					body,
					mdxAST,
					frontmatter: {
						// template,
						section,
						heading,
						links,
						tags,
						tag,
						title,
						description,
						cover,
						virtual,
						hidden,
						fullWidth,
						hideTopSection,
						switcherData,
						switcherInit,
						staticLink,
						duration,
						experimental,
						preview,
						dbSwitcher,
						langSwitcher,
						codeStyle,
						highlight,
						draft,
						releaseDate,
						customPagination,
						divider,
						icon,
					},
				},
			},
		) => {
			const parts = slug.split('/')
			const topLevel = parts.length == 3 && parts[parts.length - 1] === 'index' ? true : false
			let { items: prevItems } = acc
			const slicedParts = parts.slice(1, -1)
			const newParams = `${langSwitcher ? `${langSwitcher[0]}${dbSwitcher ? '-' : ''}` : ''}${
				dbSwitcher ? `${dbSwitcher[0]}` : ''
			}`
			for (const part of slicedParts) {
				let tmp = prevItems && prevItems.find(({ label }) => label == part)
				if (tmp) {
					if (!tmp.items) {
						tmp.items = []
					}
				} else {
					tmp = {
						// template,
						heading,
						links,
						tags,
						tag,
						label: part,
						items: [],
						topLevel,
						experimental,
						preview,
						staticLink,
					}
					prevItems.push(tmp)
				}
				if (parts[parts.length - 1] === 'index' && parts[parts.length - 2] === part) {
					tmp.url = `${urlGenerator(modSlug)}${newParams ? '-' + newParams : ''}`
					tmp.slug = slug
					tmp.title = title
					tmp.description = description
					tmp.cover = cover
					tmp.virtual = virtual
					tmp.hidden = hidden
					tmp.fullWidth = fullWidth
					tmp.hideTopSection = hideTopSection
					tmp.switcherData = switcherData
					tmp.switcherInit = switcherInit
					tmp.customPagination = customPagination
					tmp.releaseDate = releaseDate
					tmp.staticLink = staticLink
					tmp.duration = duration
					tmp.experimental = experimental
					tmp.preview = preview
					tmp.topLevel = topLevel
					tmp.codeStyle = codeStyle
					tmp.highlight = highlight
					tmp.draft = draft
					tmp.tags = tags
					tmp.tag = tag
					tmp.body = body
					tmp.mdxAST = mdxAST
					tmp.section = section
					tmp.divider = divider
					tmp.icon = icon
				}
				if (defaultCollapsed && location) {
					defaultCollapsed[part.toLowerCase()] =
						tmp.topLevel || tmp.staticLink ? null : getCollapseState(modSlug, location)
				}

				prevItems = tmp.items
			}
			const slicedLength = parts.length - 1
			const existingItem = prevItems.find(({ label }) => label === parts[slicedLength])

			if (!existingItem) {
				prevItems.push({
					label: parts[slicedLength],
					url: `${urlGenerator(modSlug)}${newParams ? '-' + newParams : ''}`,
					slug: slug,
					items: [],
					title,
					description,
					cover,
					virtual,
					hidden,
					fullWidth,
					hideTopSection,
					switcherData,
					switcherInit,
					customPagination,
					releaseDate,
					staticLink,
					duration,
					experimental,
					preview,
					topLevel,
					codeStyle,
					highlight,
					draft,
					tags,
					tag,
					body,
					mdxAST,
					section,
					divider,
					icon,
				})
			}

			return acc
		},
		{ items: [] },
	)

export default calculateTreeData
